module.exports = __webpack_public_path__ + "media/scanSuccess.138500e5.wav";